export const imagePlaceholder = '/img/placeholder/error_image_placeholder.png'
export const videoPlaceholder = '/img/placeholder/icon-video.svg'
